import { config } from '../config'

export type SocialType = keyof typeof config.urls

type Params = {
  searchParams: {
    tariff?: string
    zakaz_id?: string
    evirma_user_id?: string
    user_id_evirma?: string
  }
  social: keyof typeof config.urls
  type: keyof (typeof config.urls)[SocialType]
}

export const getLink = ({ searchParams, type, social }: Params) => {
  const queryParams = new URLSearchParams(searchParams)
  return `${config.urls[social][type]}?${queryParams.toString()}`
}
